<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication">Christ keep the Hollow Land <br/>Through the sweet spring-tide <br/>When the apple blossoms bless <br/>The lowly bent hill side. <br/> <br/>Christ keep the Hollow Land <br/>All the summer-tide <br/>Still we cannot understand <br/>Where the waters glide. <br/> <br/>Only dimly seeing them <br/>Coldly slipping through <br/>Many green-lipp’d cavern mouths, <br/>Where the hills are blue. <br/> <br/>—W<span class="smallcaps">ILLIAM </span>M<span class="smallcaps">ORRIS</span> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// hollowland_00000.vue?172ba0bd